import React, { useState } from 'react';
import { Collapse } from 'react-collapse';
import styled from 'styled-components';
import FoundTemplates from './FoundTemplates';

export default function DisplayFolder({
  handleCheckTemplate,
  isLoad,
  errMess,
  selectedTemplateId,
  folder,
  searchFieldWidth,
  tabSelected,
}) {
  if (errMess) {
    return <FolderErrMess>{errMess}</FolderErrMess>;
  }

  const [isOpened, setIsOpened] = useState(false);
  const toggleIsOpened = () => setIsOpened(!isOpened);

  const ImgArrow = styled.img`
    justify-self: flex-end;
    margin-left: 10px;
    width: 25px;
    height: 25px;
    transition: 0.3s;
    transform: ${isOpened ? 'rotate(270deg)' : 'rotate(90deg)'};
  `;
  const Item = styled.div`
    width: ${searchFieldWidth === '100%' ? '100%' : '80%'};
    margin: 15px auto 0px auto;
    box-sizing: border-box;
    border: 2px solid #c1c1c1;
    border-radius: 5px;
    box-shadow: 3px 3px 2px #afafaf;
  `;

  return (
    <Item>
      <Name onClick={toggleIsOpened}>
        <Text>{folder.folder_name}</Text>
        <ImgArrow
          // eslint-disable-next-line global-require
          src={require('../../../images/arrow-black.png')}
          alt="arrow"
          isOpened={isOpened}
        />
      </Name>
      <Collapse isOpened={isOpened}>
        <FoundTemplates
          templates={folder.items}
          handleCheckTemplate={handleCheckTemplate}
          isLoad={isLoad}
          errMess={errMess}
          selectedTemplateId={selectedTemplateId}
          toggleIsOpened={toggleIsOpened}
          tabSelected={tabSelected}
        />
      </Collapse>
    </Item>
  );
}

const Text = styled.div`
  width: 100%;
`;

const Name = styled.div`
  position: relative;
  cursor: pointer;
  width: 100%;
  height: 40px;
  padding: 0 10px 0 10px;
  text-align: center;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  background: #fff;
  box-sizing: border-box;
  border-bottom: 1px solid #c1c1c1;

  @media (max-width: 500px) {
    font-size: 16px;
  }
  @media (max-width: 350px) {
    font-size: 14px;
  }
`;

const FolderErrMess = styled.div`
  color: #afafaf;
  font-size: 20px;
  margin: 20px 0;
`;



// WEBPACK FOOTER //
// ./src/Components/Common/FindTemplateContainer/DisplayFolder.jsx